import * as style from "./Text.css";

export const p = (props: Object) => <p className={style.p} {...props} />;
